var TableListItem = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-TableListItem',
	};

	$.extend(true, this.options, options);

};

TableListItem.prototype.init = function() {
	// Apply Now functionality is now handled by Modal trigger system
	// Buttons use href="#apply-now" and are handled in Modal.js
};

export default TableListItem;
